import { Injectable } from '@angular/core';
import { SlackNotificationService } from './slack-notification.service';
import { IpexUserInformationService } from './ipex-user-information.service';

@Injectable({
    providedIn: 'root'
})
export class PerformanceTrackerService {
    incrementalSizeLimitInMb: number = 100; // 1000 means 1 gb so will get notified on 1, 2, 3, ... , 10 gb
    alreadyNotified = false;
    alreadyNotifiedTracker: boolean[] = new Array<boolean>(20);
    constructor(
        private slackNotificationService: SlackNotificationService,
        private ipexUserInformationService: IpexUserInformationService
    ) {
        for (let i = 0; i <= 10; i++) {
            this.alreadyNotifiedTracker[i] = false;
        }
    }

    trackMemoryUsage() {
        try {
            let memoryUsage: MemoryInfo = null;
            if ((window.performance as any).memory) {
                memoryUsage = (window.performance as any).memory;
            } else if ((console as any).memory) {
                memoryUsage = (console as any).memory;
            }

            if (memoryUsage) {
                for (let i = 10; i >= 1; i--) {
                    if (this.alreadyNotifiedTracker[i] === false) {
                        if (memoryUsage.usedJSHeapSize / 1000000 >= this.incrementalSizeLimitInMb * i) {

                            this.notify(`usedJSHeapSize exceeded ${this.incrementalSizeLimitInMb * i} mb`, memoryUsage);
                            this.alreadyNotifiedTracker[i] = true;
                            break;
                        }
                    } else {
                        break;
                    }
                }
            }
        } catch (error) {
            console.error('Memory usage error', error);
        }
    }

    notify(message: string, memoryInfo: MemoryInfo) {
        const userEmail = this.ipexUserInformationService.currentUserInformation?.Email ?? '';
        this.slackNotificationService
            .sendDynamicSlackMessage({
                Message: message,
                RequestUrl: window.location.href,
                MemoryUsage: memoryInfo as any,
                UserEmail: userEmail
            })
            .subscribe();
    }
}

export interface MemoryInfo {
    jsHeapSizeLimit: number;
    totalJSHeapSize: number;
    usedJSHeapSize: number;
}
